import React, { useMemo } from 'react';
import classnames from 'classnames';
import { Trans, useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { CreditsInfosBlock } from '../../../components/Features/CreditsInfosBlock';

const useStyles = createUseStyles((theme: Theme) => ({
  infosContainer: {
    width: '100%',
    display: 'flex',
    backgroundColor: 'white',
    borderRadius: theme.borderRadius.std,
    padding: [[theme.marginBase * 4, theme.marginBase * 6]],
    gap: theme.marginBase * 6,
    [theme.media.tablet]: {
      flexDirection: 'column',
    },
  },
  infoBlockContainer: {
    flex: 1,
  },
  strong: {
    fontWeight: 'bold',
    color: theme.colors.blueAccessible,
  },
}));

interface Props {
  className?: string;
}

export const SpecialOfferInfo = ({ className }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const components = useMemo(
    () => ({
      b: <strong className={classes.strong} />,
    }),
    [classes],
  );

  return (
    <div className={classnames(classes.infosContainer, className)}>
      <div className={classes.infoBlockContainer}>
        <CreditsInfosBlock
          icon="ri-heart-line"
          title={t('billing.specialOffer.infosBlock.money.title')}
        >
          <Trans
            i18nKey="billing.specialOffer.infosBlock.money.description"
            components={components}
          />
        </CreditsInfosBlock>
      </div>
      <div className={classes.infoBlockContainer}>
        <CreditsInfosBlock
          icon="ri-gift-line"
          title={t('billing.specialOffer.infosBlock.time.title')}
        >
          <Trans
            i18nKey="billing.specialOffer.infosBlock.time.description"
            components={components}
          />
        </CreditsInfosBlock>
      </div>
      <div className={classes.infoBlockContainer}>
        <CreditsInfosBlock
          icon="ri-sparkling-2-line"
          title={t('billing.specialOffer.infosBlock.team.title')}
        >
          <Trans
            i18nKey="billing.specialOffer.infosBlock.team.description"
            components={components}
          />
        </CreditsInfosBlock>
      </div>
    </div>
  );
};
